import type { Nullable } from "@core/domain/types/nullable.type";
import { LoadLayoutStore } from "@core/presentation/components/feedback/load-layout/load-layout.store";
import type { PlotFile, PlotFileUpload } from "@farm/domain/models/plot.model";
import { PlotFileDeleteUseCase } from "@farm/domain/usecases/plot-file-delete.usecase";
import { PlotFileUploadUseCase } from "@farm/domain/usecases/plot-file-upload.usecase";
import { BaseViewModel } from "@iot-platform/core";
import { inject, injectable } from "inversify";
import { action, makeObservable, observable } from "mobx";

@injectable()
export class PlotModalFormViewmodel extends BaseViewModel {
    @observable
    plotFile: Nullable<PlotFile> = null;

    @observable
    documentUrl: Nullable<string> = null;

    constructor(
        @inject(PlotFileUploadUseCase)
        private readonly plotFileUploadUseCase: PlotFileUploadUseCase,
        @inject(PlotFileDeleteUseCase)
        private readonly plotFileDeleteUseCase: PlotFileDeleteUseCase,
    ) {
        super();
        makeObservable(this);
    }

    @action
    async addPlotFile(
        plotId: string,
        farmId: string,
        file: File,
    ): Promise<void> {
        LoadLayoutStore.start();

        const fileData: PlotFileUpload = {
            file: file,
        };

        const uploadedFile = await this.plotFileUploadUseCase.execute(
            plotId,
            farmId,
            fileData,
        );

        if (uploadedFile) {
            this.plotFile = uploadedFile;
        }

        LoadLayoutStore.finish();
    }

    @action
    async deletePlotFile(farmId: string, plotId: string): Promise<void> {
        const fileDeleted = await this.plotFileDeleteUseCase.execute(
            farmId,
            plotId,
        );
        if (fileDeleted) {
            this.plotFile = null;
            this.documentUrl = null;
        }
    }

    @action
    setPlotFile(documentUrl: string): void {
        this.documentUrl = documentUrl;
    }
}
